'use strict';

import './lib/buttons';
import './lib/nav';

import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import Swup from 'swup';

// include all modules for easier js management with page transitions
// import '../../_includes/modules/pardotForm/pardotForm';
import CustomCursor from '../../_includes/modules/customCursor/customCursor';
import HeroGeometric from '../../_includes/modules/hero/heroGeometric';
import Homepage from '../../_includes/modules/homepage/homepage';
import PopupVideoModal from '../../_includes/modules/homepage/popupVideoModal';
import LoadCurtain from '../../_includes/modules/loadCurtain/loadCurtain';
import PageCurtain from '../../_includes/modules/pageCurtain/pageCurtain';
import Panorama from '../../_includes/modules/panorama/panorama';
import CompanyModal from '../../_includes/modules/searchAndFilter/companyModal';
import SearchAndFilter from '../../_includes/modules/searchAndFilter/searchAndFilter';
import TeamList from '../../_includes/modules/teamList/teamList';
import VideoPlayer from '../../_includes/modules/videoPlayer/videoPlayer';
import CheckboxToggle from './lib/checkboxToggle';

// register modules
const moduleClasses = {
  CheckboxToggle,
  CompanyModal,
  HeroGeometric,
  Homepage,
  LoadCurtain,
  Panorama,
  PopupVideoModal,
  SearchAndFilter,
  TeamList,
  VideoPlayer,
};

// keep track of active modules
let modules = [];
let isMinQueryM;

/**
 * Initialize modules on elements with data-module="ModuleName"
 */
function initModules() {
  const $moduleElements = document.querySelectorAll('[data-module]');
  $moduleElements.forEach(($element) => {
    const id = $element.dataset.module;
    const ModuleClass = moduleClasses[id];
    if (!ModuleClass) return;

    const module = new ModuleClass($element);
    modules.push(module);
  });
}

initModules();

/**
 * removes module functionality and resets DOM
 */
function unmountModules() {
  modules.forEach((module) => module.unmount() );
  modules = [];
}

/**
 * update measurements for screen size behavior
 */
function updateMeasurements() {
  isMinQueryM = window.innerWidth >= 769;
}

updateMeasurements();

// -------------------------- Persistant modules -------------------------- //

const $pageCurtain = document.querySelector('[data-js="PageCurtain"]');
const $customCursor = document.querySelector('[data-js="CustomCursor"]');
const pageCurtain = new PageCurtain($pageCurtain);
new CustomCursor($customCursor);

// -------------------------- swup page transitions -------------------------- //

const swup = new Swup({
  containers: ['.swupContainer'],
  // do not trigger swup on #hash links, let browser handle
  // do not trigger on going back to home on mobile
  ignoreVisit: (url, {el}) => {
    const isSamePage = el && getIsSamePage(url);
    const isMobileHome = el && !isMinQueryM && getIsHome(url);
    return isSamePage || isMobileHome;
  },
  plugins: [
    new SwupJsPlugin([
      {
        from: '(.*)',
        to: '(.*)',
        out: (next) => {
          pageCurtain.startOutro(() => {
            window.scrollTo(0, 0);
            next();
          });
        },
        in: (next) => {
          pageCurtain.startIntro(next);
        },
      },
    ]),
    new SwupHeadPlugin({
      persistTags: 'style',
      awaitAssets: true,
    }),
    new SwupBodyClassPlugin(),
  ],
});

swup.on('transitionStart', () => {
  unmountModules();
});

swup.on('transitionEnd', () => {
  initModules();
  reloadScripts();
  updateMeasurements();
});

const link = document.createElement('a');

/**
 * check if url is on the same page, used for #hash links
 * @param {String} url
 * @return {Boolean}
 */
function getIsSamePage(url) {
  link.href = url;
  const fullUrl = new URL(link.href);
  return fullUrl.pathname === window.location.pathname;
}

/**
 * check if url is homepage
 * @param {String} url
 * @return {Boolean}
 */
function getIsHome(url) {
  link.href = url;
  const fullUrl = new URL(link.href);
  return fullUrl.pathname === '/';
}

/**
 * reload <script> tags in <body> to execute them after page transition
 */
function reloadScripts() {
  const $scripts = document.querySelectorAll('.swupContainer script');
  $scripts.forEach(($script) => {
    const $freshScript = document.createElement('script');
    // copy attributes
    for ( const attr of $script.attributes ) {
      $freshScript.setAttribute( attr.name, attr.value );
    }
    $freshScript.setAttribute('async', 'false');
    // copy inner script code
    $freshScript.innerHTML = $script.innerHTML;
    $script.replaceWith($freshScript);
  });
}
